import { render } from "./SubletApprovalModal.vue?vue&type=template&id=20a882b2&scoped=true"
import script from "./SubletApprovalModal.vue?vue&type=script&lang=js"
export * from "./SubletApprovalModal.vue?vue&type=script&lang=js"

import "./SubletApprovalModal.vue?vue&type=style&index=0&id=20a882b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a882b2"]])

export default __exports__